import { Button } from "@/common/button";
import { EButtonType } from "@/common/button/button-models";
import { PopupEmoj } from "@/common/popups/common/popup-emoj";
import React from "react";

export const PopupMessagingDisabled = React.memo(
  function PopupMessagingDisabled(props: { onClose: () => void }) {
    return (
      <PopupEmoj
        title="Messaging disabled"
        sentence="Sending messages to this user is disabled."
      >
        {/* .cancelButtonWrapper (mt-1.5) was defined in the old SCSS but
        never actually referenced here — this div used styles.wrapper,
        which didn't exist, so no margin has ever applied. Preserved as-is. */}
        <div>
          <Button buttonType={EButtonType.BlueWide} onClick={props.onClose}>
            Close
          </Button>
        </div>
      </PopupEmoj>
    );
  }
);
